export const navMixin = {
  methods: {
    selectedItem (routeName) {
      return routeName === this.$route.name
    }
  }
}
